import React from "react";
import { ICnaesPalmeira } from "../../../../shared/interfaces/IBCI";

interface Props {
    cnaes?: ICnaesPalmeira[];
}
export const PalmeiraCnaes: React.FC<Props> = ({ cnaes }) => {
    return (
        <>
            <p style={{ breakBefore: "always" }} className="font-semibold">
                CNAES PERMITIDOS NO ZONEAMENTO
            </p>

            <table className="table">
                <thead>
                    <tr style={{ background: "#D0CECE" }}>
                        <th className="font-semibold">CNAE</th>
                        <th className="font-semibold">DESCRIÇÃO</th>
                    </tr>
                </thead>
                <tbody>
                    {cnaes?.map((cnae) => (
                        <tr key={cnae.cnae}>
                            <td>{cnae.cnae}</td>
                            <td>{cnae.descricao}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};
